module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "XMRLogo.26608d9e.svg";